import { useId } from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { Typography } from '@blade/ui-kit'
import { Checkbox } from '@root/shared/ui-kit'

type Props = {
  checked: boolean
  onChange: (checked: boolean) => void
}

export const AnnouncementShowToggle = ({ checked, onChange }: Props) => {
  const { t } = useTranslation()
  const id = useId()

  return (
    <Root>
      <Checkbox
        id={id}
        checked={checked}
        onCheckedChange={(checked) => {
          if (typeof checked === 'boolean') {
            onChange(checked)
          }
        }}
      />
      <NoteLabel htmlFor={id}>
        {t('unsafe-url-dialog.dont-show-this-warning-again')}
      </NoteLabel>
    </Root>
  )
}

const Root = styled(Typography).attrs({
  variant: 'body4-medium',
  component: 'div',
})`
  color: var(--text-10);

  cursor: pointer;

  display: grid;
  grid-template-columns: auto auto;
  gap: 6px;
  place-items: center;
`

const NoteLabel = styled.label`
  color: var(--text-10);
  cursor: pointer;

  font-size: var(--typography-body-4-medium-font-size);
  line-height: var(--typography-body-4-medium-line-height);
  font-weight: var(--typography-body-4-medium-font-weight);
`
